import { useMutation } from "@tanstack/react-query";
import { signup } from "../api/auth";

export default function useSignup() {
    return useMutation({
        mutationFn: signup,
    });
}
